import { Action } from '@ngrx/store';

export const LOGOUT = '[Security] Logout';

export class LogoutAction implements Action {
  readonly type = LOGOUT;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/LogoutAction.ts